// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_gridContainer__NKNBu {
    margin: 2rem 0 3rem 0 !important;
    padding-left: 2rem !important;
    text-align: center !important;
}

.styles_btnAdd__N42aw{
    background: #18316E !important;
    border: none !important;
    color: #FFF !important;
}

.styles_btnAdd_disabled__Ha-Tj{
    background: #C9C9C9 !important;
    border: none !important;
    color: #FFF !important;
}

.styles_rowContainer__blb\\+D{
    align-items: center;
    color: #18316E !important;
    display: flex;
    margin-top: 1rem;
    padding: 0 2rem;
    width: 100%;
}

.styles_rowContent__3RQpd{
    align-items: center;
    border-radius: 4px;
    box-shadow: 1px 1px 3px #C9C9C9;
    cursor: grab;
    display: flex;
    justify-content: space-between;
    margin-left: 1rem;
    padding: .5rem 1rem;
    width: 100%;
}

.styles_rowText__i-f1t{
    align-items: center;
    display: flex;
}

.styles_rowText_content__va-DJ{
    align-items: center;
    display: flex;
    margin-left: 1rem;
}

.styles_containerActions__TS59R{
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin: 1rem;
}

.styles_selected__VsNJN{
    color: #18316E;
}

.styles_notSelected__wjr1U{
    color: #C9C9C9;
}

.styles_deleteContent__urcX6{
    color: #18316E;
    position: relative;
    text-align: center;
}

.styles_deleteButtons__eBcJG{
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 2rem 1rem 0 1rem;
}

.styles_encurtar__rU0g2{
    color: #18316E !important;
    border-color: #18316E !important;
}

.styles_substituir__LNAgE{
    background-color: #18316E !important;

}

.styles_substituir_disable__AWeUj{
    background-color: #C6C6C6 !important;
    color: #FFF !important;
}

.styles_btnClose__x10ZT{
    cursor: pointer !important;
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
}

.styles_msgVazio__3PcWt{
    color: #18316E;
    margin-left: 2rem;
}


`, "",{"version":3,"sources":["webpack://./src/pages/Workflow/ModalWorflow/styles.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".gridContainer {\n    margin: 2rem 0 3rem 0 !important;\n    padding-left: 2rem !important;\n    text-align: center !important;\n}\n\n.btnAdd{\n    background: #18316E !important;\n    border: none !important;\n    color: #FFF !important;\n}\n\n.btnAdd_disabled{\n    background: #C9C9C9 !important;\n    border: none !important;\n    color: #FFF !important;\n}\n\n.rowContainer{\n    align-items: center;\n    color: #18316E !important;\n    display: flex;\n    margin-top: 1rem;\n    padding: 0 2rem;\n    width: 100%;\n}\n\n.rowContent{\n    align-items: center;\n    border-radius: 4px;\n    box-shadow: 1px 1px 3px #C9C9C9;\n    cursor: grab;\n    display: flex;\n    justify-content: space-between;\n    margin-left: 1rem;\n    padding: .5rem 1rem;\n    width: 100%;\n}\n\n.rowText{\n    align-items: center;\n    display: flex;\n}\n\n.rowText_content{\n    align-items: center;\n    display: flex;\n    margin-left: 1rem;\n}\n\n.containerActions{\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n    margin: 1rem;\n}\n\n.selected{\n    color: #18316E;\n}\n\n.notSelected{\n    color: #C9C9C9;\n}\n\n.deleteContent{\n    color: #18316E;\n    position: relative;\n    text-align: center;\n}\n\n.deleteButtons{\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    padding: 2rem 1rem 0 1rem;\n}\n\n.encurtar{\n    color: #18316E !important;\n    border-color: #18316E !important;\n}\n\n.substituir{\n    background-color: #18316E !important;\n\n}\n\n.substituir_disable{\n    background-color: #C6C6C6 !important;\n    color: #FFF !important;\n}\n\n.btnClose{\n    cursor: pointer !important;\n    position: absolute !important;\n    right: 0 !important;\n    top: 0 !important;\n}\n\n.msgVazio{\n    color: #18316E;\n    margin-left: 2rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `styles_gridContainer__NKNBu`,
	"btnAdd": `styles_btnAdd__N42aw`,
	"btnAdd_disabled": `styles_btnAdd_disabled__Ha-Tj`,
	"rowContainer": `styles_rowContainer__blb+D`,
	"rowContent": `styles_rowContent__3RQpd`,
	"rowText": `styles_rowText__i-f1t`,
	"rowText_content": `styles_rowText_content__va-DJ`,
	"containerActions": `styles_containerActions__TS59R`,
	"selected": `styles_selected__VsNJN`,
	"notSelected": `styles_notSelected__wjr1U`,
	"deleteContent": `styles_deleteContent__urcX6`,
	"deleteButtons": `styles_deleteButtons__eBcJG`,
	"encurtar": `styles_encurtar__rU0g2`,
	"substituir": `styles_substituir__LNAgE`,
	"substituir_disable": `styles_substituir_disable__AWeUj`,
	"btnClose": `styles_btnClose__x10ZT`,
	"msgVazio": `styles_msgVazio__3PcWt`
};
export default ___CSS_LOADER_EXPORT___;
